




































import Vue from 'vue';

export default Vue.extend({
  name: 'CustomerDetailGroups',
  components: {},
  computed: {
    getUserId() {
      return parseInt(this.$route.params.id);
    },
    customerMediaLikesQuery() {
      return {
        customerId: this.getUserId,
      };
    },
  },
  data() {
    return {
      customerMediaLikesFields: [
        {
          name: 'item',
        },
      ],
    };
  },
  methods: {
    viewMedia(data) {
      this.$router.push({
        name: 'media-library-view-item',
        params: {
          media_id: data.media_id,
        },
      });
    },
  },
});
